import Icon from '../components/Icon';

const Rocky = Icon(
  'rocky',
  <>
    <path d="M3.5 2 5 3.5 3.5 5 2 3.5zM12 2l1.5 1.5L12 5l-1.5-1.5zM12 7l-1.5 1.5L12 10l1.5-1.5zM12 12l1.5 1.5L12 15l-1.5-1.5zM12 17l-1.5 1.5L12 20l1.5-1.5zM20.5 2 22 3.5 20.5 5 19 3.5zM22 8.5 20.5 7 19 8.5l1.5 1.5zM20.5 12l1.5 1.5-1.5 1.5-1.5-1.5zM22 18.5 20.5 17 19 18.5l1.5 1.5zM5 8.5 3.5 7 2 8.5 3.5 10zM3.5 12 5 13.5 3.5 15 2 13.5zM5 18.5 3.5 17 2 18.5 3.5 20zM7.75 4.5 9.25 6l-1.5 1.5L6.25 6zM9.25 10.657l-1.5-1.5-1.5 1.5 1.5 1.5zM7.75 13.985l1.5 1.5-1.5 1.5-1.5-1.5zM9.25 20.314l-1.5-1.5-1.5 1.5 1.5 1.5zM16.25 4.5l1.5 1.5-1.5 1.5-1.5-1.5zM17.75 10.657l-1.5-1.5-1.5 1.5 1.5 1.5zM16.25 13.985l1.5 1.5-1.5 1.5-1.5-1.5zM17.75 20.314l-1.5-1.5-1.5 1.5 1.5 1.5z" />
  </>
);

export default Rocky;
